// src/router/index.js

import {createRouter, createWebHistory} from 'vue-router'

const hasLoginToken = () => Boolean(localStorage.getItem('token'))
const isAdminUser = () => {
    const sessionFlag = sessionStorage.getItem('user_is_admin')
    if (sessionFlag === 'true' || sessionFlag === 'false') return sessionFlag === 'true'
    return localStorage.getItem('user_is_admin') === 'true'
}

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),  // history 模式
    routes: [
        {
            path: '/home',
            name: 'home',
            component: () => import(`@/components/home.vue`),
            meta: {
                title: '首页',
                requiresAuth: true,
            },
        },
        {
            path: '/ranking',
            name: 'ranking',
            component: () => import(`@/components/ranking.vue`),
            meta: {
                title: '排名',
                requiresAuth: true,
            },
        },
        {
            path: '/admin',
            name: 'admin',
            component: () => import(`@/components/admin.vue`),
            meta: {
                title: '管理员',
                requiresAuth: true,
                adminOnly: true,
            },
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(`@/components/login.vue`),
            meta: {
                title: '登录',
            },
        },
        {
            // Magic Link 注册落地（/register?lt=<token>）。复用 login.vue，
            // 由组件 onMounted 读取 lt、切到注册 tab 并解析。
            path: '/register',
            name: 'register',
            component: () => import(`@/components/login.vue`),
            meta: {
                title: '注册',
            },
        },
        {
            path: '/',
            redirect: () => {
                if (!hasLoginToken()) return '/login'
                return isAdminUser() ? '/admin' : '/home'
            },
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/',
        },
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta?.title) document.title = to.meta.title

    const loggedIn = hasLoginToken()
    const admin = isAdminUser()

    if (to.path === '/login' && loggedIn) {
        next(admin ? '/admin' : '/home')
        return
    }
    if (to.meta?.requiresAuth && !loggedIn) {
        next('/login')
        return
    }
    if (to.meta?.adminOnly && !admin) {
        next('/home')
        return
    }
    next()
})

export default router